import styled, { createGlobalStyle, css } from 'styled-components'
import { ThemeSelectors } from '@at/design-system-foundation'

export const GlobalStyle = createGlobalStyle<{ scrollBehaviour?: boolean }>`
    ${({ scrollBehaviour }) => {
        return css`
            ${scrollBehaviour &&
            css`
                html {
                    scroll-behavior: smooth;
                }
            `}
        `
    }}  
`

export const StyledSearchResults = styled.article`
    width: 100%;
    margin: 0 auto;
    display: block;
    grid-template-columns: repeat(1, 1fr);
    column-gap: 12px;
    padding: 0px ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 2}px;
    @media (min-width: 1272px) {
        padding: ${({ theme }) => ThemeSelectors.getGridUnit(theme)} 0;
    }

    @media (min-width: 768px) {
        padding: ${({ theme }) => ThemeSelectors.getGridUnit(theme)} 24px;
    }
    @media (min-width: 1024px) {
        padding: ${({ theme }) => ThemeSelectors.getGridUnit(theme)} 40px;
    }
    @media (min-width: 1728px) {
        max-width: 1646px;
        padding: ${({ theme }) => ThemeSelectors.getGridUnit(theme)} 0;
    }

    .search-filters-input .atds-field__input {
        height: 48px;
        font-size: 14px;
        border-color: ${({ theme }) => theme.color.border.input};
    }

    .search-filters-input.atds-field--error .atds-field__input {
        border-color: ${({ theme }) => theme.color.border.critical};
    }
`
